{
  "rwg-cancel-request-page": {
    "buttons": {
      "cancel": "Abbrechen",
      "submit": "Einreichen",
      "to-home-page": "Zur Startseite"
    },
    "meta": {
      "title": "Beauty Pro - Antrag auf Deaktivierung der Google-Integration",
      "description": "Füllen Sie das folgende Formular aus, um die Deaktivierung unserer Google-Integration auf Ihrer Google-Karte zu beantragen"
    },
    "text": {
      "title": "Antrag auf Deaktivierung der Google-Integration",
      "subtitle-salon-info": "Wo ist Ihr Salon?",
      "subtitle-owner-info": "Wie können wir mit Ihnen Kontakt aufnehmen?",
      "email": "Ihre E-Mail",
      "full-name": "Ihr Name",
      "language": "Ihre bevorzugte Kommunikationssprache",
      "request-sent-success": "Ihre Anfrage wurde erfolgreich gesendet!",
      "request-confirmation-sent-to-your-email": "Unsere Bestätigung wird an Ihre E-Mail geschickt. Bitte überprüfen Sie auch Ihren Spam-Ordner!",
      "salon-address": "Adresse Ihres Salons",
      "salon-name": "Name Ihres Salons",
      "we-will-contact-soon": "Unser Team steht Ihnen gerne zur Verfügung und wird sich in Kürze mit Ihnen in Verbindung setzen, um Ihre Anfrage zu bearbeiten."
    }
  }
}
